module.exports = __webpack_public_path__ + "img/s-title.76d8a56a.png";